import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
   Grid,
   GridItem,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   // Box,
   // Stepper,
   // Step,
   // StepIndicator,
   // StepStatus,
   // StepIcon,
   // StepNumber,
   // StepTitle,
   // StepDescription,
   // StepSeparator,
   useToast,
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { renderFormControl } from 'utils/DynamicFormData';
import { getCountries, addCountry, updateCountry } from '../../../../../redux/actions/country';
import '../../../companyProfile/css.css';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';

// Yup Validation Schema
const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
   nationality: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
});

// const steps = [
//   { title: 'First', description: 'Enter Color Information' },
//   { title: 'Second', description: 'Review and Save' },
// ];

const CountryMasterForm = ({ isOpen, onClose, isEditMode = false, demoname, currentRow = null, saveandcontinue = true }) => {
   const [row, setRow] = useState({
      name: '',
      nationality: '',
      code: '',
      status: '',
   });

   const [errors, setErrors] = useState({});
   // const [activeStep, setActiveStep] = useState(0);
   const toast = useToast();
   const textColor = useColorModeValue('#9E9E9E', 'white');
   const dispatch = useDispatch();

   // Function to clear form data
   const clearFormData = () => {
      setRow({
         name: '',
         nationality: '',
         code: '',
         status: '',
      });
      setErrors({});
   };

   useEffect(() => {
      if (demoname && row.name === '') {
         setRow((prev) => ({ ...prev, name: demoname }));
      }
      demoname = '';
   }, [demoname, row.name]);

   // Populate form with current row data when in edit mode
   useEffect(() => {
      if (!isEditMode) {
         clearFormData(); // Clear data when adding a new item
      } else if (isEditMode && currentRow) {
         setRow({
            name: currentRow.name || '',
            nationality: currentRow.nationality || '',
            code: currentRow.code || '',
            status: currentRow.status || '',
         });
      }
   }, [isEditMode, currentRow]);

   const validateStep = async () => {
      try {
         // Validate the whole row object instead of individual fields
         await validationSchema.validate(row, { abortEarly: false });

         setErrors({}); // Clear previous errors
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      setRow((prev) => ({
         ...prev,
         [field]: value,
      }));

      // Clear the specific field error when user starts typing
      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const onFormSubmit = async () => {
      const processedData = {
         ...row,
         status: row.status ? 1 : 0,
         // ordinal: Number(row.ordinal),
         // primaryuqcid: Number(row.primaryuqcid),
         // ratepersalesid: Number(row.ratepersalesid),
         // rateperpurchaseid: Number(row.rateperpurchaseid)
      };
      try {
         if (isEditMode && currentRow && currentRow.id) {
            // Update existing item
            processedData.id = currentRow.id;
            await dispatch(updateCountry(processedData));
         } else {
            // Add new item
            await dispatch(addCountry(processedData));
         }
         dispatch(getCountries());
         // Close the modal
         onClose();
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Country.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const onsavecontinue = async () => {
      const processedData = {
         ...row,
         status: row.status ? 1 : 0,
         // ordinal: Number(row.ordinal),
         // primaryuqcid: Number(row.primaryuqcid),
         // ratepersalesid: Number(row.ratepersalesid),
         // rateperpurchaseid: Number(row.rateperpurchaseid)
      };
      try {
         if (isEditMode && currentRow && currentRow.id) {
            // Update existing item
            processedData.id = currentRow.id;
            await dispatch(updateCountry(processedData));
         } else {
            // Add new item
            await dispatch(addCountry(processedData));
         }
         dispatch(getCountries());
         clearFormData();
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Country.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onsavecontinue(); // Call the form submit logic if validation is successful
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handleSubmit = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit(); // Call the form submit logic if validation is successful
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handleCansel = async () => {
      onClose();
      if (!isEditMode) {
         clearFormData();
      }
   };

   return (
      <Modal isOpen={isOpen} onClose={handleCansel} size="4xl">
         <ModalOverlay />
         <ModalContent
            bg={useColorModeValue('white', '#2d3748')}
            color={useColorModeValue('gray.800', 'white')}
            borderRadius="20px"
            p={0}
            mx="15px"
            mt={{ base: '45%', md: '20%', xl: '10%' }}
            boxShadow="lg">
            <ModalHeader fontSize="20px" fontWeight="600" mb={{ base: 0, xl: 4 }}>
               {isEditMode ? 'Edit Country' : 'Add New Country'}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               {/* <Stepper index={activeStep} colorScheme="teal">
            {steps.map((step, index) => (
              <Step key={index}>
                <StepIndicator>
                  <StepStatus
                    complete={<StepIcon />}
                    incomplete={<StepNumber />}
                    active={<StepNumber />}
                  />
                </StepIndicator>
                <Box flexShrink="0">
                  <StepTitle>{step.title}</StepTitle>
                  <StepDescription>{step.description}</StepDescription>
                </Box>
                <StepSeparator />
              </Step>
            ))}
          </Stepper> */}

               {/* {activeStep === 0 && ( */}
               <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }} gap={2}>
                  <GridItem className="seperator-width">
                     {DynamicInput(
                        'name',
                        'Name',
                        {
                           value: row.name,
                           onChange: (e) => handleInputChange('name', e.target.value),
                        },
                        errors,
                        textColor,
                        'text',
                        true, // optional: mark as required
                     )}
                  </GridItem>
                  <GridItem className="seperator-width">
                     {DynamicInput(
                        'nationality',
                        'NATIONALITY',
                        {
                           value: row.nationality,
                           onChange: (e) => handleInputChange('nationality', e.target.value),
                        },
                        errors,
                        textColor,
                        'text',
                        true, // optional: mark as required
                     )}
                  </GridItem>
                  <GridItem className="seperator-width">
                     {DynamicInput(
                        'code',
                        'CODE',
                        {
                           value: row.code,
                           onChange: (e) => handleInputChange('code', e.target.value),
                        },
                        errors,
                        textColor,
                        'text',
                        // true, // optional: mark as required
                     )}
                  </GridItem>
               </Grid>
               {/* )} */}

               {/* {activeStep === 1 && (
            <Box mt={8}>
              <strong>Name:</strong> {row.name}
              <br />
              <strong>Ordinal:</strong> {row.ordinal}
              <br />
            </Box>
          )} */}
            </ModalBody>
            <ModalFooter>
               {/* {activeStep > 0 && (
            <Button
              onClick={handlePrevious}
              variant="ghost"
              colorScheme="teal"
              mr={3}
            >
              Previous
            </Button>
          )}

          {activeStep < steps.length - 1 && (
            <Button onClick={handleNext} colorScheme="teal">
              Next
            </Button>
          )} */}
               {!isEditMode && (saveandcontinue === true) && (
                  <Button onClick={handlesavecontinue} colorScheme="green" ml={3}>
                     Save & continue
                  </Button>
               )}
               <Button onClick={handleSubmit} colorScheme="green" ml={3}>
                  {isEditMode ? 'Update' : 'Save & Finish'}
               </Button>

               <Button variant="ghost" onClick={handleCansel} ml={3}>
                  Cancel
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default CountryMasterForm;
